import axios from "axios";
import { BASE_URL } from "../../config";

export const getStatusStepper = async (siteId, partnerId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/site-activities/status/${siteId}/${partnerId}`
      );
      resolve(response.data);
    } catch (error) {
      console.error("Error getStatusStepper:", error);
      reject(error);
    }
  });
};
